import { IoPaperPlaneOutline } from "react-icons/io5";
import { BiBrain } from "react-icons/bi";
import { HiOutlineLightBulb } from "react-icons/hi";

const Data = [
  {
    icon: <IoPaperPlaneOutline size={40} color="red" />,
    Tittle: "Future Concept.",
    Para: "Create interactive content to encourage your audience Which can help increase brand awareness and drive traffic to your website",
  },
  {
    icon: <BiBrain size={40} color="red" />,
    Tittle: "The Big Ideas.",
    light :true,
    Para: "Develop a brand story that resonates with your target audience and use it as the foundation for all of your marketing efforts.",
  },
  {
    icon: <HiOutlineLightBulb size={40} color="red" />,
    Tittle: "Creative Solutions.",
    Para: "Use marketing automation tools to streamline your marketing efforts and free up your team to focus on strategy and creativity.",
  },
];

export default Data;
